// import the react components
import React, {useState} from "react";
import OuterHeader from "./../ui/outer-header";
import Footer from "./../components/footer";
import useAuth from "./../context/auth";
import {update_date} from "./../assets/data/general";
import {privacy_sections} from "./../assets/data/privacy";

// the privacy page
const Privacy = () => {
    const {auth} = useAuth();
    const [open, setOpen] = useState(1);

    // toggle accordion
    const toggle = id => {
        setOpen(open === id ? null : id);
    };

    // return to the component data
    return (
        <div>
            {!auth && <OuterHeader />}

            <div className="min-h-screen px-5 py-12">
                <div className="max-w-5xl mx-auto">
                    <div className="text-center mb-14">
                        <h1 className="text-6xl font-black tracking-tight text-gray-900 dark:text-white mb-5">Privacy Policy</h1>
                        <p className="text-sm text-gray-700 dark:text-gray-400">Last Updated: {update_date}</p>
                    </div>

                    <div className="flex flex-col gap-4">
                        {privacy_sections.map(({id, title, content}) => {
                            const isOpen = open === id;

                            return (
                                <div
                                    key={id}
                                    className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                                        isOpen ? "border-primary border-2 bg-gray-50" : "border-gray-200 border-2 dark:border-gray-800 bg-gray-50"
                                    }`}
                                >
                                    <button onClick={() => toggle(id)} className="w-full flex items-center justify-between px-6 py-5 text-left">
                                        <div className="flex items-center gap-4">
                                            <span className="text-xs font-bold text-primary bg-primary/10 px-3 py-1 rounded-full">
                                                {String(id).padStart(2, "0")}
                                            </span>

                                            <span className="font-medium text-gray-900 text-base sm:text-lg">
                                                {title}
                                            </span>
                                        </div>

                                        <span className={`text-primary text-2xl transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}>
                                            +
                                        </span>
                                    </button>

                                    {isOpen && (
                                        <div className="px-6 pb-6">
                                            {content}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};
export default Privacy;